// src/components/stats/PlayerHeader.jsx -- presentational player header: headshot
// avatar + name + adaptive subtitle. Position added in #849, jersey in #998 PR 3.
// The subtitle (playerSubtitle) is ADAPTIVE 3-max: TEAM · POSITION · #JERSEY when
// rich, TEAM · LEAGUE as the floor when both position and jersey are absent; a null
// segment drops cleanly (no dangling separator). Specs docs/specs/2026-08-13-849-*,
// docs/specs/2026-08-13-998-jersey-avatar-design.md.

import { playerSubtitle } from '../../lib/player-stats-display';
import PlayerAvatar from './PlayerAvatar';

export default function PlayerHeader({ player }) {
  const name = player?.name || '';
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '4px 0 12px' }}>
      <PlayerAvatar playerId={player?.player_id} league={player?.league} name={name} />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontWeight: 800, fontSize: 18, color: '#fff' }}>{name}</div>
        <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 700, marginTop: 2 }}>
          {playerSubtitle(player)}
        </div>
      </div>
    </div>
  );
}
